import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-3 col-sm-6 col-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_4 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "title ms-15" }
const _hoisted_7 = { class: "fw-black mb-8 lh-1" }
const _hoisted_8 = { class: "col-md-3 col-sm-6 col-12" }
const _hoisted_9 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_10 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "title ms-15" }
const _hoisted_13 = { class: "fw-black mb-8 lh-1" }
const _hoisted_14 = { class: "col-md-3 col-sm-6 col-12" }
const _hoisted_15 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_16 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "title ms-15" }
const _hoisted_19 = { class: "fw-black mb-8 lh-1" }
const _hoisted_20 = { class: "col-md-3 col-sm-6 col-12" }
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_22 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "title ms-15" }
const _hoisted_25 = { class: "fw-black mb-8 lh-1" }
const _hoisted_26 = { class: "col-md-3 col-sm-6 col-12" }
const _hoisted_27 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_28 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "title ms-15" }
const _hoisted_31 = { class: "fw-black mb-8 lh-1" }
const _hoisted_32 = { class: "col-md-3 col-sm-6 col-12" }
const _hoisted_33 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_34 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "title ms-15" }
const _hoisted_37 = { class: "fw-black mb-8 lh-1" }
const _hoisted_38 = { class: "col-md-3 col-sm-6 col-12" }
const _hoisted_39 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_40 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "title ms-15" }
const _hoisted_43 = { class: "fw-black mb-8 lh-1" }
const _hoisted_44 = { class: "col-md-3 col-sm-6 col-12" }
const _hoisted_45 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_46 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_47 = { class: "d-flex align-items-center" }
const _hoisted_48 = { class: "title ms-15" }
const _hoisted_49 = { class: "fw-black mb-8 lh-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Colis Livrés Facturés ", -1)),
              _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.dashCount?.Parcels?.deliveredparcelsinvoiced ?? 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-success" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Colis Livrés Non Facturés ", -1)),
              _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.dashCount?.Parcels?.deliveredparcelsnotinvoiced ?? 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-warning" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Colis En cours ", -1)),
              _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.dashCount?.Parcels?.inprogressparcels ?? 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-danger" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_24, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Colis Retournés ", -1)),
              _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.dashCount?.Parcels?.returnedparcels ?? 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-info" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_30, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Produits ", -1)),
              _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.dashCount?.Products ?? 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_36, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Bons de Livraison ", -1)),
              _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.dashCount?.BL ?? 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-secondary" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_42, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Bons de retour ", -1)),
              _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.dashCount?.BR ?? 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-success" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_48, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Factures ", -1)),
              _createElementVNode("h4", _hoisted_49, _toDisplayString(_ctx.dashCount?.INV ?? 0), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}